import { render } from "./IgnoreEvents.vue?vue&type=template&id=3affa16e&scoped=true"
import script from "./IgnoreEvents.vue?vue&type=script&lang=js"
export * from "./IgnoreEvents.vue?vue&type=script&lang=js"

import "./IgnoreEvents.vue?vue&type=style&index=0&id=3affa16e&lang=css"
import "./IgnoreEvents.vue?vue&type=style&index=1&id=3affa16e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3affa16e"]])

export default __exports__